import React, { useMemo } from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import createExpanderCell from '../gridcomponents/ExpanderCell';

const expanderIconWidth = 17;
const indentSize = 16;
const bin = (x) => (x ? 1 : 0);
const defaultIndent = (row) => (
    indentSize * (row.level) // Indent 16px per row
        + expanderIconWidth * bin(!row.children) // Add extra indent if expander button not used
);

const withRowExpanders = (Component) => {
    const RowExpandersWrapper = (props) => {
        const rows = useMemo(() => {
            const rowsById = fp.indexBy('id', props.rows);
            const isRowExpanded = (row) => (!row.parentId)
              || (rowsById[row.parentId].expanded && isRowExpanded(rowsById[row.parentId]));
            return props.rows.filter(isRowExpanded);
        }, [props.rows]);

        const columns = useMemo(() => {
            const mapColumn = ({ expander, ...c }) => ({
                ...c,
                Cell: c.renderCell || c.Cell || (expander && createExpanderCell(
                    () => null,
                    props.useDefaultIndent ? defaultIndent : undefined,
                    props.onExpanderClick
                )) || undefined
            });

            const mapColumnGroup = (c) => (c.columns
                ? {
                    ...c,
                    columns: c.columns.map(mapColumnGroup)
                }
                : mapColumn(c)
            );
            return props.columns.map(mapColumnGroup);
        }, [props.columns, props.useDefaultIndent, props.onExpanderClick]);

        return (
            <Component { ...props } rows={ rows } columns={ columns } />
        );
    };
    RowExpandersWrapper.propTypes = {
        onExpanderClick: PropTypes.func,
        useDefaultIndent: PropTypes.bool,
        rows: PropTypes.shape([]),
        columns: PropTypes.shape([])
    };

    RowExpandersWrapper.defaultProps = {
        onExpanderClick: fp.noop,
        useDefaultIndent: true,
        rows: [],
        columns: []

    };
    return RowExpandersWrapper;
};

export default withRowExpanders;
